import { type TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { capitalize } from '@ember/string';

export interface DropdownItemSignature {
  Element: HTMLDivElement;
  Args: {
    key?: string | number;
    value?: string;
    translationKey?: string;
    unfilterable?: boolean;
  };
  Blocks: { default: [] };
}

const DropdownItem: TOC<DropdownItemSignature> = <template>
  <div
    class={{concat 'item' (if @unfilterable ' unfilterable disabled')}}
    data-value={{@key}}
    ...attributes
  >
    {{#if @value}}
      {{@value}}
    {{else if @translationKey}}
      {{capitalize (t (concat @translationKey (concat '.' @key)))}}
    {{else}}
      {{yield}}
    {{/if}}
  </div>
</template>;
export default DropdownItem;
